import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Layout,
  Flex,
  Card,
  Row,
  Col,
  Select,
  Radio,
  Table,
  Badge,
  Divider,
  Button,
  Spin,
  Avatar,
  Tag,
  Checkbox,
  Input,
  Tooltip as AntTooltip,
  Segmented,
  Tabs,
  DatePicker,
  Image,
} from "antd";
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  LabelList,
} from "recharts";

import {
  FilterOutlined,
  InfoCircleOutlined,
  MoreOutlined,
  RiseOutlined,
  FallOutlined,
  EllipsisOutlined,
  UserOutlined,
  DownOutlined,
  UpOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
  CloseOutlined,
  CloseCircleOutlined,
  SearchOutlined,
  CloudFilled,
  EditOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import "./NewDashboard.css";
import axios from "axios";
import { BE_HOST } from "../../config/config";
import AlertMessage from "./AlertMessage/AlertMessage";
import HeaderCompo from "../../component/Header";
import { axiosInstance } from "../../utils/axiosInterceptor";
import logo from "../../assets/marketPlacelogo.png";
import CalculationModal, {
  BPRTooltipTable,
  GCRMonthlyToolTipTable,
  GCRTooltipTable,
  GPRTooltipTable,
  RebateToolTiplTable,
} from "./calculationModal/CalculationModal";
import { setPharmacyData, setPharmacyLabel } from "../../redux/reducer/dataReducer";
import { formatMonthLabel, formatQuarterLabel } from "../../utils/helper";
import Chat from "../../components/chats/Chat";
import InputPopUp from "../../components/InputPopUp/InputPopUp";
import { QuarterTargetTable, SGCRTargetTable } from "../../components/tables/NarrowTable";
import dayjs from 'dayjs';
const { Content } = Layout;
const { Option } = Select;

const generateHeaderData = () => {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  const currentDate = new Date();
  const monthData = [];
  const quarterData = [];


  const currentMonth = currentDate.getUTCMonth();
  const currentYear = currentDate.getUTCFullYear();

  for (let i = 11; i >= 0; i--) {
    const date = new Date(currentDate);
    date.setMonth(date.getUTCMonth() - i);

    const month = date.getUTCMonth();
    const year = date.getUTCFullYear();
    monthData.push({
      label: `${months[month]} ${year}`,
      value: `${month + 1}`,
      key: `${months[month]} ${year}`,
    });
  }

  for (let i = 0; i < 4; i++) {
    const date = new Date(currentDate);
    date.setMonth(date.getUTCMonth() - i * 3);
    const quarter = Math.floor(date.getUTCMonth() / 3) + 1;
    const year = date.getUTCFullYear();

    quarterData.unshift({
      label: `${quarter}${getOrdinalSuffix(quarter)} Quarter ${year}`,
      value: `${quarter}`,
      key: `${quarter}${getOrdinalSuffix(quarter)} Quarter ${year}`,
    });
  }

  return {
    month: monthData,
    quarter: quarterData,
  };
};

const getOrdinalSuffix = (num) => {
  const suffixes = ["th", "st", "nd", "rd"];
  const v = num % 100;
  return suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0];
};

const getHeaderdata = generateHeaderData();
const { TabPane } = Tabs;

const NewDashboard = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const accountIdParams = searchParams.get("accountId");
  const accountName = searchParams.get("accountName");
  const [AllUser, setAllUser] = useState([]);
  const [selectedPharmacies, setSelectedPharmacies] = useState(accountIdParams ? [Number(accountIdParams)] : []);
  const [selectedfilter, setselectedfilter] = useState("month");
  const [selectedfilter2, setselectedfilter2] = useState("month");

  const [rebatePerformance, setRebatePerformace] = useState([]);
  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false);
  const [loadingCalc, setloadingCalc] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [activePeriod, setActivePeriod] = useState("current");
  const [quarterGCRTarget, setQuarterGCRTarget] = useState("");
  const [SGCRTarget, setSGCRTarget] = useState("");
  const [GPRTarget, setGPRTarget] = useState("");
  const [inputTargetValue, setInputTarget] = useState();
  const [year, setYear] = useState(new Date().getUTCFullYear());
  const [GCRPer, setAPIdata] = useState([]);
  const [TopRxSpentSQL, setTopRxSpentSQL] = useState([]);
  const [TopLeakDetails, setTopLeakDetails] = useState([]);
  const [TrailingData, setTrailingData] = useState([]);
  const [QuarterGCR, setQuarterGCR] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState(AllUser);
  const [allUserFetched, setAllUserFetched] = useState(false);
  const [calculatedData, setCalculatedData] = useState([]);
  const [gcrPercentage, setGcrPercentage] = useState([]);
  const [selectedGcr, setSelectedGcr] = useState(null);
  const [animateValues, setAnimateValues] = useState(false);
  const [quarterGcrPer, setQuarterGcrPercentage] = useState([]);
  const [monthSgcrPer, setMonthSgcrPercentage] = useState([]);
  const [monthGprPer, setMonthGrPercentage] = useState([]);
  const [chatBoxOpen, setChatOpen] = useState(false);
  const [adminChatBot, setAdminChat] = useState(false);
  const [admin, setAdmin] = useState(true);
  const [targetPopUP, setTargetPopUp] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [targetLoading, setTargetLoading] = useState(false);
  const [QuarterTableData, setQuarterTableData] = useState([])
  const [SgcrTableData, setSgcrTableData] = useState([])
  const [accSelectedOption, setAccSelectedOption] = useState("")
  const [bprData, setBprData] = useState([])
  const [GCRMonthlyData, setGCRMonthlyData] = useState([])
  const [totalRebateTableInfo, setTotalRebateTableInfo] = useState([])


  const dispatch = useDispatch();
  const { loading } = useSelector(
    (state) => state.accounts || { assignedAccounts: [], loading: false }
  );
  const userAuth = useSelector((state) => state.userAuth.decodedToken?.user);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const getCurrentMonthOption = () => {
    const now = dayjs();

    const label = now.format("MMM YYYY");
    const monthValue = now.format("M");
    const year = now.format("YYYY");

    return {
      key: label,
      label: label,
      value: monthValue,
      year: year,
    };
  };

  const [selectedOption, setSelectedOption] = useState(getCurrentMonthOption());

  const updatePharmacies = (value, pharmacy) => {
    setSelectedPharmacies(value);
    setAccSelectedOption(pharmacy?.at(-1)?.options)
    dispatch(setPharmacyData(value));
    dispatch(setPharmacyLabel(pharmacy?.at(-1)?.name));
  };


  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingNew,setIsLoadingNew] = useState(false)
  const [searchText, setSearchText] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const getDateRange = (filter, selectedValue, selectedYear) => {
    if (filter === "quarter") {
      const quarters = {
        1: { start: "01-01", end: "03-31" },
        2: { start: "04-01", end: "06-30" },
        3: { start: "07-01", end: "09-30" },
        4: { start: "10-01", end: "12-31" },
      };
      return {
        fromDate: `${selectedYear}-${quarters[selectedValue].start}`,
        thruDate: `${selectedYear}-${quarters[selectedValue].end}`,
      };
    } else {
      const today = new Date();
      const month = selectedValue.padStart(2, "0");
      const startDate = `${selectedYear}-${month}-01`;
      const thruDate =
        today.getUTCFullYear() === parseInt(selectedYear) &&
          today.getUTCMonth() + 1 === parseInt(selectedValue)
          ? today.toISOString().split("T")[0]
          : new Date(selectedYear, selectedValue, 0)
            .toISOString()
            .split("T")[0];

      return { fromDate: startDate, thruDate };
    }
  };

  const apiVersion =
    Number(selectedOption?.year) > 2025 ||
      (Number(selectedOption?.year) === 2025 && Number(selectedOption.value) >= 9) ? "" : "";
  const apiVersionUsers =
    Number(selectedOption?.year) > 2025 ||
      (Number(selectedOption?.year) === 2025 && Number(selectedOption.value) >= 9) ? "" : "";

  const isBeforeOrEqualMarch2026 =
    Number(selectedOption?.year) < 2026 ||
    (Number(selectedOption?.year) === 2026 && Number(selectedOption?.value) <= 3);

  const fetchAllData = async () => {
    if (!token) return;
    setIsLoadingNew(true)
    setIsLoading(true);
    try {
      setIsLoading(true);

      const { fromDate, thruDate } = getDateRange(
        selectedfilter,
        selectedOption.value,
        selectedOption?.year
      );

      const getUserAccount = await axiosInstance.get(
        `${BE_HOST}${apiVersionUsers}/users/accounts?email=${userAuth?.email}`
      );
      setAllUser(getUserAccount.data.data.data);

      if (
        getUserAccount?.data?.data?.data?.length > 0 &&
        selectedPharmacies?.length > 0
      ) {
        const gcrRes = await axiosInstance.get(
          `/api${apiVersion}/powerbi/getGCRPercentage?token=${token}&period=${selectedfilter}&value=${selectedOption.value}&year=${selectedOption?.year}&accounts=${selectedPharmacies}`
        );
        setAPIdata(gcrRes.data);
        setIsLoadingNew(false)
        if (gcrRes.data) {
          await Promise.all([
            axiosInstance
              .get(
                `${BE_HOST}/users/gpr/top-leakage?skip=0&take=30&FromDate=${fromDate}&ThruDate=${thruDate}&store_id=${selectedPharmacies}`
              )
              .then((LeakDetails) => setTopLeakDetails(LeakDetails?.data?.data)),

            axiosInstance
              .get(
                `${BE_HOST}/api${apiVersion}/powerbi/table/getTopRxSpentSQL?period=${selectedfilter}&value=${selectedOption.value}&year=${selectedOption?.year}&accounts=${selectedPharmacies}`
              )
              .then((RxSpentSQL) => setTopRxSpentSQL(RxSpentSQL.data.results)),

            axiosInstance
              .get(
                `${BE_HOST}/api${apiVersion}/powerbi/table/getGPRTrailingData?accounts=${selectedPharmacies}&period=${selectedfilter}&value=${selectedOption.value}&year=${selectedOption?.year}`
              )
              .then((ApiTrailing) => {
                const sortedData = [...ApiTrailing.data.data].sort((a, b) => {
                  return (
                    new Date(b.sort_date).getTime() -
                    new Date(a.sort_date).getTime()
                  );
                });
                setTrailingData(sortedData);
              }),

            selectedfilter === "quarter" &&
            axiosInstance
              .get(
                `/api/powerbi/getQuarterGCR?token=${token}&period=${selectedfilter}&value=${selectedOption.value}&year=${selectedOption?.year}&accounts=${selectedPharmacies}&quarters=${selectedOption.value}`
              )
              .then((ApiQuarterGCR) => {
                setQuarterGCR(ApiQuarterGCR.data);
              }),
            axiosInstance
              .get(
                `/api${apiVersion}/powerbi/getRebateSummaryLast7Months?token=${token}&period=${selectedfilter}&value=${selectedOption.value}&year=${selectedOption?.year}&accounts=${selectedPharmacies}`
              )
              .then((ApiMonthlyRebateValues) => {
                setRebatePerformace(ApiMonthlyRebateValues.data);
              }),
          ]);
        }
      }
    } catch (err) {
      console.error("Error fetching dashboard data:", err);
    } finally {
      setIsLoading(false);
      setAllUserFetched(true);
    }
  };

  const fetchCalculationData = async (item = null, gcrp) => {
    let data = {};
    if (selectedPharmacies?.length == 0 || !selectedOption?.value) {
      return;
    }
    if (item !== null) {
      setselectedfilter2(item?.selectedfilter);
      data.accounts = selectedPharmacies?.join(",");
      data.view = item?.selectedfilter;
      data.year = item?.year;
      if (item?.selectedGcr) {
        // data.tier = item?.selectedGcr || tierValue;
        data.tier = item?.selectedGcr;
      }
      if (item?.selectedfilter === "month") {
        data.month = item?.selectedOption?.value;
      } else {
        data.quarter = item?.selectedOption?.value;
      }
    } else {
      data.accounts = selectedPharmacies?.join(",");
      data.month = new Date().getUTCMonth() + 1;
      data.year = new Date().getUTCFullYear();;
      // target: gcrper
      data.view = "month";
    }
    setloadingCalc(true);
    try {
      const response = await axiosInstance.get(`/users/gcr/optimizer`, {
        params: data,
      });
      setCalculatedData(response?.data);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setloadingCalc(false);
    }
  };

  const fetchgprPercentage = async (item = null, itemnew = null) => {
    if (!accSelectedOption) return;
    try {
      const currentView = item || selectedfilter2;
      const response = await axiosInstance.get(`/users/gcr/limits`, {
        params: {
          view: currentView,
          category: accSelectedOption
        },
      });
      const data = response?.data?.tiers || [];
      setGcrPercentage(data);
      fetchCalculationData(itemnew, response?.data?.tiers);
    } catch (error) {
      console.error("Error:", error);
    } finally {
    }
  };


  const fetchGcrData = async (view, setter) => {
    if (!accSelectedOption) return;
    try {
      const response = await axiosInstance.get(`/users/data/gcr`, {
        params: { view, category: accSelectedOption },
      });
      const data = response?.data?.rawTiers || [];
      setter(data);
    } catch (error) {
      console.error(`Error fetching ${view} GCR/SGCR:`, error);
    }
  };

  const fetchgprPerData = async () => {
    if (!accSelectedOption) return;
    try {
      const response = await axiosInstance.get(`/users/data/gpr?category=${accSelectedOption}`);
      const data = response?.data?.tiers || [];
      setMonthGrPercentage(data);
    } catch (error) {
      console.error("Error:", error);
    } finally {
    }
  };
  const getBPRData = async () => {
    if (!accSelectedOption) return;
    try {
      const response = await axiosInstance.get(`/users/data/bpr?category=${accSelectedOption}`);
      const data = response?.data?.tiers || [];
      setBprData(data);
    } catch (error) {
      console.error("Error:", error);
    } finally {
    }
  };
  const getGCrMonthly = async () => {
    if (!accSelectedOption) return;
    try {
      const response = await axiosInstance.get(`/users/data/monthly/gcr?category=${accSelectedOption}`);
      const data = response?.data?.tiers || [];
      setGCRMonthlyData(data);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      getTotalRebateTable()
    }
  };
  const getTotalRebateTable = async () => {
    if (!accSelectedOption) return;
    try {
      const response = await axiosInstance.get(`/users/data/rebates?category=${accSelectedOption}`);
      const data = response?.data?.tiers || [];
      setTotalRebateTableInfo(data);
    } catch (error) {
      console.error("Error:", error);
    } finally {
    }
  };

  useEffect(() => {
    fetchgprPercentage();
    fetchGcrData("quarter", setQuarterGcrPercentage);
    fetchGcrData("month", setMonthSgcrPercentage);
    fetchgprPerData();
    getBPRData()
    getGCrMonthly()

  }, [accSelectedOption]);

  useEffect(() => {
    fetchCalculationData();
  }, [GCRPer, selectedPharmacies]);

  useEffect(() => {
    if (!allUserFetched) return;
    if (AllUser?.length > 0 && selectedPharmacies?.length === 0) {
      const specialUser = AllUser?.find((user) => user?.acct_id === 96167);
      if (specialUser) {
        setSelectedPharmacies([specialUser?.acct_id]);
        setAccSelectedOption(specialUser?.options)
        dispatch(setPharmacyData([specialUser?.acct_id]));
        dispatch(setPharmacyLabel(specialUser?.name))
      } else {
        setSelectedPharmacies([AllUser[0]?.acct_id]);
        dispatch(setPharmacyData([AllUser[0]?.acct_id]));
        dispatch(setPharmacyLabel(AllUser[0]?.name))
        setAccSelectedOption(AllUser[0]?.options)
      }
    } else if (AllUser?.length == 0 && selectedPharmacies.length === 0) {
      setModalVisible(true);
    }
  }, [AllUser, selectedPharmacies, allUserFetched]);

  const GenericRx = Number(
    isNaN(GCRPer?.raw_data?.Generic_Rx) ? 0 : GCRPer?.raw_data?.Generic_Rx || 0
  ).toFixed(2);

  const OnStopGeneric = Number(
    isNaN(GCRPer?.raw_data?.OnStop_Generic)
      ? 0
      : GCRPer?.raw_data?.OnStop_Generic || 0
  ).toFixed(2);

  const TotalRx = Number(
    isNaN(GCRPer?.raw_data?.Total_Rx) ? 0 : GCRPer?.raw_data?.Total_Rx || 0
  ).toFixed(2);

  const Brand_Rx = Number(
    isNaN(GCRPer?.raw_data?.Brand_Rx) ? 0 : GCRPer?.raw_data?.Brand_Rx || 0
  ).toFixed(2);

  const estimatedCurrentRebate = Number(
    isNaN(GCRPer?.raw_data?.estimatedCurrentRebate)
      ? 0
      : GCRPer?.raw_data?.estimatedCurrentRebate || 0
  ).toFixed(2);

  // Last Period

  const last_GenericRx = Number(
    isNaN(GCRPer?.lastMetrics?.Generic_Rx)
      ? 0
      : GCRPer?.lastMetrics?.Generic_Rx || 0
  ).toFixed(2);

  const last_OnStopGeneric = Number(
    isNaN(GCRPer?.lastMetrics?.OnStop_Generic)
      ? 0
      : GCRPer?.lastMetrics?.OnStop_Generic || 0
  ).toFixed(2);

  const last_TotalRx = Number(
    isNaN(GCRPer?.lastMetrics?.Total_Rx)
      ? 0
      : GCRPer?.lastMetrics?.Total_Rx || 0
  ).toFixed(2);

  const last_Brand_Rx = Number(
    isNaN(GCRPer?.lastMetrics?.Brand_Rx)
      ? 0
      : GCRPer?.lastMetrics?.Brand_Rx || 0
  ).toFixed(2);

  const last_estimatedCurrentRebate = Number(
    isNaN(GCRPer?.lastMetrics?.estimatedCurrentRebate)
      ? 0
      : GCRPer?.lastMetrics?.estimatedCurrentRebate || 0
  ).toFixed(2);

  const performanceData = [
    {
      metric: "Total Rx Spend",
      lastPeriod: last_GenericRx,
      thisPeriod: GenericRx,
    },
    {
      metric: "Total Brand Rx Spend",
      lastPeriod: last_Brand_Rx,
      thisPeriod: Brand_Rx,
    },
    {
      metric: "Total Generic Rx Spend",
      lastPeriod: last_TotalRx,
      thisPeriod: TotalRx,
    },
    {
      metric: "One-STOP Generic Spend",
      lastPeriod: last_OnStopGeneric,
      thisPeriod: OnStopGeneric,
    },
    {
      metric: "Estimated Current Rebate",
      lastPeriod: last_estimatedCurrentRebate,
      thisPeriod: estimatedCurrentRebate,
    },
  ];

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = date.getUTCDate();

    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return `${n}th`;
      switch (n % 10) {
        case 1:
          return `${n}st`;
        case 2:
          return `${n}nd`;
        case 3:
          return `${n}rd`;
        default:
          return `${n}th`;
      }
    };

    const month = date.toLocaleString("en-US", { month: "long", timeZone: "UTC" });
    const year = date.getUTCFullYear();

    return `${getOrdinal(day)} ${month}, ${year}`;
  };

  const staticGPRData = [
    { period: "Sep 22", threeMonthAvg: 78, sixMonthAvg: 48 },
    { period: "Oct 22", threeMonthAvg: 36, sixMonthAvg: 30 },
    { period: "Nov 22", threeMonthAvg: 63, sixMonthAvg: 66 },
    { period: "Dec 22", threeMonthAvg: 48, sixMonthAvg: 59 },
    { period: "Jan 23", threeMonthAvg: 72, sixMonthAvg: 77 },
    { period: "Feb 23", threeMonthAvg: 66, sixMonthAvg: 90 },
  ];

  // const fetchLeakageData = async()=>{
  //   try {
  //     const response = axiosInstance.
  //   } catch (error) {
      
  //   }
  // }
  useEffect(() => {
    fetchAllData();
    // fetchLeakageData()
    // getTargetData();
    setAnimateValues(true);
    const timer = setTimeout(() => setAnimateValues(false), 500);
    return () => clearTimeout(timer);
  }, [selectedfilter, selectedOption, selectedPharmacies]);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Step 1: Transform and Sort Data
  const processedRebateData = [...rebatePerformance]
    .map((item) => ({
      ...item,
      month: `${monthNames[item.month_num - 1]} ${item.year}`,
    }))
    .sort((a, b) => {
      if (a.year !== b.year) return b.year - a.year;
      return b.month_num - a.month_num;
    });

  useEffect(() => {
    const filtered = AllUser.filter(
      (user) => {
        const { displayName, displayId } = getDisplayPharmacy(user);
        return (
          displayName.toLowerCase().includes(searchText.toLowerCase()) ||
          String(displayId || "").includes(searchText)
        )
      }
    );
    setFilteredUsers(filtered);
  }, [searchText, AllUser]);

  const isCurrentMonth = (monthData) => {
    const now = new Date();
    const currentMonth = now.getUTCMonth() + 1;
    const currentYear = now.getUTCFullYear();

    if (
      parseInt(monthData.value) === currentMonth &&
      monthData.key.includes(currentYear)
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleTarget = (label, val) => {
    setSelectedValue(label);
    setInputTarget(val);
    setTargetPopUp(true);
  };

  // const getTargetData = async () => {
  //   if (selectedPharmacies?.length === 0 || !selectedOption?.year) return;
  //   setTargetLoading(true);
  //   try {
  //     const response = await axiosInstance.get(
  //       `${BE_HOST}/powerbi/targets?accounts=${selectedPharmacies}&period=month&year=${selectedOption?.year}&month=${Number(selectedOption?.value)}&email=${userAuth?.email}`
  //     );
  //     const filterData = response?.data?.targets;
  //     if (filterData?.length > 0) {
  //       setQuarterGCRTarget(filterData[0]?.Quarter_GCR);
  //       setSGCRTarget(filterData[0]?.Month_SGCR);
  //       setGPRTarget(filterData[0]?.Month_GPR);
  //     }
  //   } catch (error) {
  //     console.log(error, "error in gettargetDataaaa");
  //   } finally {
  //     setTargetLoading(false);
  //   }
  // };

  const isSelectedCurrentMonth = () => {
    const currentMonth = new Date().getUTCMonth() + 1;
    return (Number(selectedOption?.value) === currentMonth && selectedOption?.year == new Date().getUTCFullYear());
  };


  useEffect(() => {
    getQuarterGCRTableData();
    // getSGCRTableData()
  }, [selectedOption, quarterGCRTarget, SGCRTarget])
  const getQuarterGCRTableData = async () => {
    const quarter = Math.ceil((new Date().getUTCMonth() + 1) / 3);
    let data = {};
    if (selectedPharmacies?.length == 0 || !selectedOption?.value || quarterGCRTarget == 0) {
      return;
    }
    data.accounts = selectedPharmacies?.join(",");
    data.quarter = quarter;
    data.year = selectedOption?.year;
    data.tier = quarterGCRTarget;
    data.view = "quarter";
    // setloadingCalc(true);
    try {
      const response = await axiosInstance.get(`/users/gcr/optimizer`, {
        params: data,
      });
      setQuarterTableData(response?.data);
    } catch (error) {
      console.error("Error:", error);
    } finally {
    }
  };
  // const getSGCRTableData = async () => {
  //   let data = {};
  //   if (selectedPharmacies?.length == 0 || !selectedOption?.value) {
  //     return;
  //   }
  //   data.accounts = selectedPharmacies;
  //   data.month = selectedOption?.value;
  //   data.year = selectedOption?.year;
  //   data.tier = SGCRTarget;
  //   data.view = "month";
  //   try {
  //     const response = await axiosInstance.get(`${apiVersionUsers}/users/gcr/optimizer`, {
  //       params: data,
  //     });
  //     setSgcrTableData(response?.data);
  //   } catch (error) {
  //     console.error("Error:", error);
  //   } finally {
  //   }
  // };


  const disabledMonth = (current) => {
    const MIN_MONTH = dayjs("2026-01", "YYYY-MM");
    const MAX_MONTH = dayjs(); // always current month
    if (!current) return false;

    return (
      current.isBefore(MIN_MONTH, "month") ||
      current.isAfter(MAX_MONTH, "month")
    );
  };
  const onChangeMonth = (date) => {
    if (!date) return;

    const label = date.format("MMM YYYY");
    const monthValue = date.format("M");
    const year = date.format("YYYY");

    const option = {
      key: label,
      label: label,
      value: monthValue,
      year: year,
    };

    setSelectedOption(option);
  };

  const getDisplayPharmacy = (account) => {
    const isGoodUser = userAuth?.user_roles_id === 5;

    if (isGoodUser && account?.acct_id === 96167) {
      return {
        ...account,
        displayName: "ABC Pharmacy",
        displayId: "123456",
      };
    }

    return {
      ...account,
      displayId: account.acct_id,
      displayName: account.name || account.label,
    };
  };

  const formatMonthYear = (date) => {
  if (!date) return "";

  const [year, month] = date.split("-");
  return `${month}-${year}`;
};


  return (
    <>
      <HeaderCompo initialColor={"#000833"} />
      <Layout className="min-h-screen p-2 dashboard-layout-bg">
        <Content className="p-6 bg-[#000833] mb-8 rounded-lg ">
          {isLoading ? (
            <div className="flex justify-center items-center h-[30vh] bg-[transparent]">
              <Spin size="large" className="text-white " />
            </div>
          ) : (
            <div className="flex flex-col justify-center align-center  sm:flex-row sm:justify-between sm:items-center mb-8 mt-2 gap-4 w-full">
              {AllUser && AllUser.length > 0 && (
                <div className="order-2 sm:order-1 w-full sm:w-auto sm:max-w-[43%] flex justify-center align-center  ">
                  <Select
                    suffixIcon={
                      <DownOutlined
                        style={{
                          color: "#fff",
                          fontSize: 20,
                          fontWeight: "700",
                        }}
                      />
                    }
                    mode="multiple"
                    value={selectedPharmacies.slice().reverse()}
                    onChange={(values, options) => {
                      const pharmacies = options.map((opt) => opt.data);
                      updatePharmacies(values, pharmacies);
                    }}
                    allowClear={false}
                    className="w-full sm:w-auto custom-selectPhar"
                    dropdownClassName="custom-dropdown"
                    // placeholder="Select pharmacies"
                    showSearch={false}
                    virtual
                    // options={AllUser?.map((account, index) => ({
                    //   label: account.name || account.label,
                    //   value: account.acct_id,
                    //   key:
                    //     account.acct_id || `pharmacy-${account.value}-${index}`,
                    // }))}
                    options={AllUser?.map((account, index) => {
                      const modified = getDisplayPharmacy(account);
                      return {
                        label: modified.displayName,
                        value: account.acct_id,
                        key: account.acct_id || `pharmacy-${index}`,
                        data: account,
                      };
                    })}
                    loading={loading}
                    maxTagCount={1}
                    open={dropdownOpen}
                    onDropdownVisibleChange={(isOpen) => {
                      setDropdownOpen(isOpen);
                      if (!isOpen) setSearchText("");
                    }}
                    tagRender={({ label, value, closable, onClose }) => {
                      const showClose = selectedPharmacies.length > 1;
                      return (
                        <Tag
                          closable={showClose}
                          onClose={onClose}
                          style={{
                            width: "100%",
                            whiteSpace:
                              label?.length > 25 ? "normal" : "nowrap",
                            wordBreak: "break-word",
                            display: "inline-block",
                            lineHeight: "1.2",
                          }}
                          // className="bg-transparent text-[20px] font-bold border-none text-white rounded-lg px-4 py-2 text-center mx-auto max-w-[90%] sm:text-[26px] break-words whitespace-wrap xs:whitespace-nowrap"
                          className="bg-transparent text-[20px] font-bold border-none text-white rounded-lg px-4 py-2 text-center mx-auto sm:text-[26px]"
                        >
                          {/* <span className="break-words text-center">{label}</span> */}
                          {AllUser?.length > 0 && selectedPharmacies
                            ? label
                            : ""}
                          {/* { AllUser && AllUser.length > 0 && label
                            ? label
                            : 'NEW-MO-TOWN PHCY'} */}
                        </Tag>
                      );
                    }}
                    filterOption={false}
                    optionLabelProp="label"
                    dropdownRender={(menu) => (
                      <div>
                        {selectedPharmacies?.length > 0 && (
                          <div className="flex flex-wrap gap-1 p-2 pt-3">
                            {selectedPharmacies.map((id) => {
                              const pharmacy = AllUser.find(
                                (acc) => acc.acct_id === id
                              );
                              if (!pharmacy) return null;
                              const { displayName } = getDisplayPharmacy(pharmacy);
                              return (
                                <Tag
                                  key={id}
                                  closable
                                  onClose={() => {
                                    const newIds = selectedPharmacies.filter((v) => v !== id);

                                    const pharmacies = AllUser.filter((acc) =>
                                      newIds.includes(acc.acct_id)
                                    );

                                    updatePharmacies(newIds, pharmacies);
                                  }
                                    // updatePharmacies(
                                    //   selectedPharmacies.filter((v) => v !== id)
                                    // )
                                  }
                                  className="flex items-center gap-1 px-2 py-0.5 border border-gray-300 rounded text-[10px] sm:text-[12px] text-black"
                                >
                                  {/* {pharmacy.name} */}
                                  {displayName}
                                </Tag>
                              );
                            })}
                          </div>
                        )}
                        <div className="flex justify-center px-2 py-2 border-b border-gray-200">
                          <div className="relative w-full">
                            <Input
                              placeholder="Search"
                              allowClear
                              value={searchText}
                              onChange={(e) => setSearchText(e.target.value)}
                              size="small"
                              onKeyDown={(e) => {
                                if (e.key === "Backspace") {
                                  e.stopPropagation();
                                }
                              }}
                              className="pr-6 text-xs rounded-sm bg-gray-100"
                            />
                            <SearchOutlined className="absolute top-1/2 right-2 -translate-y-1/2 text-gray-500 text-[12px]" />
                          </div>
                        </div>
                        <div className="max-h-60 overflow-y-auto px-2 sm:px-4 custom-scrollbar text-xs sm:text-sm max-w-100 w-full">
                          {filteredUsers.map((account) => {
                            const modified = getDisplayPharmacy(account);
                            const value = account.acct_id;
                            // const label = `${account.name?.toUpperCase?.()} (${account.acct_id
                            //   })`;
                            const label = `${modified.displayName.toUpperCase()} (${modified.displayId})`;
                            const isSelected =
                              selectedPharmacies.includes(value);
                            return (
                              <div
                                key={value}
                                className="flex items-center justify-around px-2 py-1 hover:bg-gray-100 rounded cursor-pointer w-full"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => {
                                  const newSelected = isSelected
                                    ? selectedPharmacies.filter(
                                      (id) => id !== value
                                    )
                                    : [...selectedPharmacies, value];
                                  const pharmacies = AllUser.filter((acc) =>
                                    newSelected.includes(acc?.acct_id)
                                  );
                                  updatePharmacies(newSelected, pharmacies);
                                }}
                              >
                                <div className="w-[15%]">
                                  <Checkbox checked={isSelected} />
                                </div>
                                <span className="w-[85%] text-[12px] sm:text-[13px] font-medium text-[#000833]">
                                  {label}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  />
                </div>
              )}
              <div className="order-1 sm:order-2 w-full sm:w-auto flex justify-center">
                <Image
                  style={{ marginTop: "6px", marginBottom: 20 }}
                  src={logo}
                  alt="Logo"
                  preview={false}
                  width={200}
                  height={70}
                />
              </div>

              <div className="order-3 w-full sm:w-auto flex flex-col justify-center sm:justify-end items-center gap-3">
                <DatePicker
                  picker="month"
                  onChange={onChangeMonth}
                  defaultValue={dayjs()}
                  value={selectedOption ? dayjs(selectedOption.label, "MMM YYYY") : dayjs()}
                  allowClear={false}
                  format="MMM YYYY"
                  disabledDate={disabledMonth}
                  inputReadOnly
                  className="brand-month-picker w-full md:w-[250px]"
                  dropdownClassName="brand-month-dropdown"
                  suffixIcon={<DownOutlined style={{ color: "#fff" }} />}
                />
                {
                  GCRPer?.latestInvoiceData?.invoiceDate && (
                    <div className="w-full md:w-[250px] rounded-md border border-[#4A5A7A] bg-[#1F2D4D]/90 px-1 py-2 shadow-lg">
                      <div className="text-[#fff] !text-[10px] md:text-base font-medium ml-2">
                        DATA RECEIVED THROUGH
                      </div>

                      <div className="flex items-center gap-3 mt-1 ml-2">
                        <div className="w-2 h-2 rounded-full bg-green-400 shadow-[0_0_10px_rgba(74,222,128,0.8)]" />

                        <span className="text-white text-md md:text-md font-bold text-[10px]">
                          {formatDate(GCRPer?.latestInvoiceData?.invoiceDate)}
                        </span>
                      </div>
                    </div>
                  )
                }
              </div>
            </div>
          )}
          <Row
            gutter={[24, 24]}
            className="flex flex-col sm:flex-row items-start -mb-1 sm:-mt-5"
            style={{ alignItems: 'stretch' }}
          >
            <Col xs={24} sm={12} md={12} className="w-full sm:w-1/2" style={{ display: 'flex', flexDirection: 'column' }}>
              <div className="card">
                <span className="title ">Quarterly Brand Economics</span>
                {/* {userAuth?.user_roles_id == 5 ||
                  userAuth?.user_roles_id == 2 ||
                  userAuth?.user_roles_id == 1 ? ( */}
                  <Button
                    type="default"
                    className="mr-2 md:ml-10 bg-white text-black"
                    onClick={() => setIsVisible(true)}
                  >
                    Projection Calculator
                  </Button>
                {/* ) : null} */}
              </div>
              <div className="flex flex-wrap gap-5 w-full justify-start" style={{ flex: 1 }}>
                {[
                  {
                    title: "GCR (QTD)",
                    value: Number(GCRPer?.QTD_GCR_Percentage || 0).toFixed(2),
                    next: Number(GCRPer?.Next_QTD_GCR_Percentage || 0).toFixed(
                      2
                    ),
                    last: Number(GCRPer?.Last_QTD_GCR_Percentage || 0).toFixed(
                      2
                    ),
                    monthper: Number(GCRPer?.MTD_GCR_Percentage || 0).toFixed(
                      2
                    ),
                    projectedGCR: Number(GCRPer?.projectedQuarterlyGCR || 0).toFixed(
                      2
                    ),
                    isGCRTopTier: GCRPer?.isGCRTopTier,
                  },
                  {
                    title: "BPR",
                    value: Number(GCRPer?.BPR_Percentage || 0).toFixed(2),
                    next: Number(GCRPer?.Next_QTD_BPR_Percentage || 0).toFixed(
                      2
                    ),
                    last: Number(GCRPer?.Last_QTD_BPR_Percentage || 0).toFixed(
                      2
                    ),
                    date: GCRPer?.GPR_Reporting_Period ? GCRPer?.BPR_Reporting_Period : "",
                    isBPRTopTier: GCRPer?.isBPRTopTier,
                  },
                  {
                    title: "Trending COGS (QTD)",
                    value: Number(GCRPer?.QTD_COGS || 0).toFixed(2),
                    next: Number(GCRPer?.Current_COGS || 0).toFixed(2),
                    last: Number(GCRPer?.Current_COGS || 0).toFixed(2),
                    cogs_impact: Number(GCRPer?.COGS_Impact).toFixed(2),
                    isCOGSTopTier: GCRPer?.isCOGSTopTier,
                    isCogsBPR: GCRPer?.isCogsBPR,
                    bpr: GCRPer?.BPRCogs,
                    HMCogs: GCRPer?.HmCOgs,
                    hmStatus: GCRPer?.hm_status
                  },
                ].map((item, idx) => (
                  <div key={idx} className="flex-1 min-w-[200px]" style={{ display: 'flex' }} >
                    <Card className="bg-[#DCF3FF] border-none cardAni" style={{ width: '100%' }}>
                      <div className="flex flex-col justify-between h-full">
                        <div className="flex items-start gap-3 smallCardTitle mb-2 justify-between">
                          {/* <span> */}
                          {item?.title === "BPR" ? (
                            <span>
                              {item?.title.replace(/\s*\(.*?\)/, "")}{" "}
                              {item?.date ? `(${item?.date})` : ""}
                            </span>
                          ) : <span>{item?.title}</span>
                          }
                          {/* {item.title}</span> */}
                          {item.title === "GCR (QTD)" ? <AntTooltip
                            placement="topRight"
                            color="transparent"
                            overlayInnerStyle={{
                              padding: 0,
                              boxShadow: "none",
                              background: "transparent",
                            }}
                            title={
                              <div className="w-[300px] md:w-[600px] h-[600px]">
                                <GCRTooltipTable data={quarterGcrPer} flag="Gcr" />
                              </div>
                            }
                          >
                            <InfoCircleOutlined className="text-gray-500 hover:text-blue-600 cursor-pointer" />
                          </AntTooltip>
                            : item?.title === "BPR" ? (
                              <>
                                <AntTooltip
                                  placement="topRight"
                                  color="transparent"
                                  overlayInnerStyle={{
                                    padding: 0,
                                    boxShadow: "none",
                                    background: "transparent",
                                  }}
                                  title={
                                    <div className="w-[300px] md:w-[400px]">
                                      <BPRTooltipTable data={bprData} flag="SGCR" />
                                    </div>
                                  }
                                >
                                  <InfoCircleOutlined className="text-gray-500 hover:text-blue-600 cursor-pointer" />
                                </AntTooltip>
                              </>
                            ) :
                              <AntTooltip
                                placement="topRight"
                                color="transparent"
                                overlayInnerStyle={{
                                  padding: 0,
                                  boxShadow: "none",
                                  background: "transparent",
                                }}
                                title={
                                  <div className="w-[300px] md:w-[600px]">
                                    <GCRTooltipTable data={quarterGcrPer} />
                                  </div>
                                }
                              >
                                <InfoCircleOutlined className="text-gray-500 hover:text-blue-600 cursor-pointer" />
                              </AntTooltip>
                          }
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 6,
                          }}
                        >
                          <div
                            className={`font-jetbrains smallCarddata ${animateValues ? "value-update" : ""
                              }`}
                          >
                            {item.value}%
                          </div>
                          {item?.title ===
                            "Trending COGS (QTD)" && apiVersion !== "" && (
                              <span className="text-gray-700 ml-1">
                                | COGS Impact:{" "}
                                {item?.cogs_impact == "NaN" ||
                                  item?.cogs_impact === undefined ||
                                  isLoading ? (
                                  <Spin
                                    indicator={<LoadingOutlined spin />}
                                    size="10"
                                    className="text-[#15033f] "
                                  />
                                ) : (
                                  <span
                                    className={
                                      item?.cogs_impact < 0
                                        ? "text-red-500"
                                        : "text-green-500"
                                    }
                                  >
                                    $ {item?.cogs_impact}
                                  </span>
                                )}
                              </span>
                            )}
                        </div>

                        {/* <span className="text-gray-700 mt-3">
                          Next Tier: {item?.next} %
                        </span> */}
                        <span className="text-gray-700 mt-3">
                          {(item.title === "GCR (QTD)" && item.isGCRTopTier) ||
                            (item.title === "BPR" && item.isBPRTopTier) ||
                            (item.title === "Trending COGS (QTD)" && item.isCOGSTopTier)
                            ? `Top Tier: ${item?.next} %`
                            : `Next Tier: ${item?.next} %`}
                        </span>
                        <span className="text-gray-700">
                          {item.title === "Trending COGS (QTD)"
                            ? "Current COGS"
                            : "Last Period"}
                          : {item.last} %
                        </span>

                        {item?.monthper !== undefined ? (
                          <span className="text-gray-700">
                            MTD : {item?.monthper} %
                          </span>
                        ) : null}
                        {/* <span className="text-gray-700 invisible">
                             0.00 %
                        </span> */}

                        {(item?.projectedGCR !== undefined && apiVersion !== "" && isBeforeOrEqualMarch2026) ? (
                          <span className="text-gray-700">
                            Projected GCR : {item?.projectedGCR} %
                          </span>
                        ) : null}

                        {
                          item.title === "Trending COGS (QTD)" ? (
                            <>
                              <span className={`text-gray-700 ${item?.bpr <= 0 ? "text-red-600" : "text-green-700"}`}>
                                {item?.isCogsBPR ? <> BPR : {item?.bpr?.toFixed(2)} % </> : <span className="text-gray-700 invisible">
                                  0.00 %
                                </span>}
                              </span>
                              <span className={`text-gray-700 ${item?.HMCogs <= 0 ? "text-red-600" : "text-green-700"}`}>
                                {item?.HMCogs ? <>HealthMart : {item?.HMCogs?.toFixed(2)} % </> :  <span className="text-gray-700 invisible">
                                  0.00 %
                                </span> }
                              </span>
                            </>
                          ) : null
                        }

                        {/* {GCRPer?.hm_status !== 1 && (
                          <span className="text-gray-700 invisible">0.00 %</span>
                        )} */}

                      </div>
                      {/* {item?.title === "GCR (QTD)" && (
                        <div
                          className="text-[#000833]"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 4,
                            fontSize: 16,
                            fontWeight: "600",
                            justifyContent: 'space-between'
                          }}
                        >
                          <div>
                            Target: {Number(quarterGCRTarget)?.toFixed(2) || 0.00} %
                            {isSelectedCurrentMonth() && userAuth?.user_roles_id === 5 && (
                              <EditOutlined
                                onClick={() =>
                                  handleTarget("Quarter_GCR", item?.value)
                                }
                                className="font-jetbrains text-[#000833]"
                                style={{ fontSize: 16, cursor: "pointer" }}
                              />
                            )}
                          </div>
                          {
                            (quarterGCRTarget !== 0 && quarterGCRTarget !== "") && (
                              <AntTooltip
                                placement="top"
                                color="white"
                                getPopupContainer={() => document.body}
                                overlayStyle={{ maxWidth: "none" }}
                                overlayInnerStyle={{
                                  padding: 0,
                                  boxShadow: "none",
                                  background: "transparent",
                                }}
                                title={
                                  <div className="w-[300px] md:w-[600px]">
                                    <QuarterTargetTable data={QuarterTableData} />
                                  </div>
                                }
                              >
                                <InfoCircleOutlined className="text-gray-500 hover:text-blue-600 cursor-pointer" />
                              </AntTooltip>
                            )
                          }
                        </div>
                      )} */}
                    </Card>
                  </div>
                ))}
              </div>
            </Col>

            <Col xs={24} sm={12} md={12} className="w-full sm:w-1/2" style={{ display: 'flex', flexDirection: 'column' }}>
              <div className="card">
                <span className="title">Monthly Rebates</span>
              </div>
              <div className="flex flex-wrap gap-5 w-full justify-start" style={{ flex: 1 }}>
                {[
                  {
                    title: "GCR",
                    value: Number(GCRPer?.GCR_Percentage || 0).toFixed(2),
                    next: Number(GCRPer?.Next_GCR_Percentage || 0).toFixed(
                      2
                    ),
                    last: Number(GCRPer?.Last_GCR_Percentage || 0).toFixed(
                      2
                    ),
                    date: GCRPer?.GPR_Reporting_Period ? GCRPer?.BPR_Reporting_Period : "",
                    isTopGCRRebate: GCRPer?.isTopGCRRebate,
                    brand_term_commitment_rebate_per: Number(GCRPer?.brand_term_commitment_rebate_per || 0).toFixed(2),
                    term_flag: GCRPer?.term_commitment_flag === "Y"
                  },
                  {
                    title: "GPR (Monthly)",
                    value: Number(GCRPer?.GPR_Percentage || 0).toFixed(2),
                    next: Number(GCRPer?.NEXT_GPR_Percentage || 0).toFixed(2),
                    last: Number(GCRPer?.LAST_GPR_Percentage || 0).toFixed(2),
                    date: GCRPer?.isValidReportingDate
                      ? formatMonthYear(GCRPer?.GPR_Reporting_Period)
                      : "",
                    isTopTier: GCRPer?.isTopTier,
                  },
                  {
                    title: "Total Rebate",
                    value: Number(GCRPer?.brand_total_rebate_per || 0).toFixed(2),
                    totalBrandRebate: Number(GCRPer?.brand_total_rebate_per || 0).toFixed(2),
                    totalGenricRebate: Number(GCRPer?.os_total_rebate_per || 0).toFixed(2),

                    lastBrand: Number(GCRPer?.lastBrandRebateTotal || 0).toFixed(2),
                    lastOneStop: Number(GCRPer?.lastOsRebateTotal || 0).toFixed(2),
                    health_mart_bonus: Number(GCRPer?.health_mart_bonus || 0).toFixed(2),
                  },
                ].map((item, idx) => (
                  <div key={idx} className="flex-1 min-w-[160px]" style={{ display: 'flex' }}>
                    <Card className="bg-[#DCF3FF] border-none cardAni" style={{ width: '100%' }}>
                      <div className="flex flex-col justify-between h-full">
                        <div className="flex items-center gap-3 smallCardTitle mb-2 justify-between">
                          {item?.title === "Total Rebate" ? (
                            <div className="!text-[12]">
                              <div>Brand Rebate</div>
                            </div>
                          ) : (
                            <span>
                              {item?.title === "GPR (Monthly)" ? (
                                <span>
                                  {item?.title.replace(/\s*\(.*?\)/, "")}{" "}
                                  {item?.date ? `(${item?.date})` : ""}
                                </span>
                              ) :
                                (
                                  <span>{item?.title}</span>
                                )}
                            </span>
                          )}

                          {item?.title === "GCR" ? (
                            <>
                              <AntTooltip
                                placement="topRight"
                                color="transparent"
                                overlayInnerStyle={{
                                  padding: 0,
                                  boxShadow: "none",
                                  background: "transparent",
                                }}
                                title={
                                  <div className="w-[300px] md:w-[400px]">
                                    <GCRMonthlyToolTipTable data={GCRMonthlyData} />
                                  </div>
                                }
                              >
                                <InfoCircleOutlined className="text-gray-500 hover:text-blue-600 cursor-pointer" />
                              </AntTooltip>
                            </>
                          ) : item?.title === "GPR (Monthly)" ? (
                            <AntTooltip
                              placement="top"
                              color="white"
                              getPopupContainer={() => document.body}
                              overlayStyle={{ maxWidth: "none" }}
                              overlayInnerStyle={{
                                padding: 0,
                                boxShadow: "none",
                                background: "transparent",
                              }}
                              title={
                                <div className="w-[300px] md:w-[400px]">
                                  <GPRTooltipTable data={monthGprPer} flag="GPR" />
                                  <div className="px-3 flex items-center justify-center text-sm text-blue-600 bg-white pb-3 rounded-md my-5">
                                    Reach out to IPC to gain access to more
                                    rebates
                                  </div>
                                </div>
                              }
                            >
                              <InfoCircleOutlined className="text-gray-500 hover:text-blue-600 cursor-pointer" />
                            </AntTooltip>
                          ) : (
                            <AntTooltip
                              placement="left"
                              color="transparent"
                              overlayInnerStyle={{
                                padding: 0,
                                boxShadow: "none",
                                background: "transparent",
                              }}
                              title={
                                <div className="w-[300px] md:w-[350px]">
                                  <RebateToolTiplTable data={totalRebateTableInfo} />
                                </div>
                              }
                            >
                              <InfoCircleOutlined className="text-gray-500 hover:text-blue-600 cursor-pointer" />
                            </AntTooltip>
                          )}
                        </div>

                        <div
                          className={` font-jetbrains smallCarddata ${animateValues ? "value-update" : ""
                            }`}
                        >
                          {item.value}%
                        </div>

                        {item.title !== "Total Rebate" ? (
                          <span className="text-gray-700 mt-3">
                            {
                              (item.title === "GPR (Monthly)" && item?.isTopTier) ||
                                (item.title === 'GCR') && item?.isTopGCRRebate
                                ? `Top Tier ${item?.next} %`
                                : `Next Tier ${item?.next} %`
                            }
                          </span>
                        ) : (
                          <>

                            <div className="!text-[12] !mt-[4px]" >OneStop Rebate
                              <span className={`block font-jetbrains smallCarddata ${animateValues ? "value-update" : ""
                                }`}>{item.totalGenricRebate}%</span></div>
                            <div className="text-gray-700 mt-3 leading-snug">
                              <div>Last Period Brand: {item?.lastBrand}%</div>
                              <div>Last Period OneStop: {item?.lastOneStop}%</div>
                            </div>
                            <div> <span className={`text-gray-700 ${item?.health_mart_bonus <= 0 ? "text-red-600" : "text-green-700"}`}>
                              {(item?.health_mart_bonus  && !isLoadingNew) ? <>HealthMart OneStop Rebate: {item?.health_mart_bonus} % </> :  ""}
                            </span>
                            </div>
                          </>
                        )}

                        {item.title !== "Total Rebate" && (
                          <span className="text-gray-700">
                            Last Period: {item?.last} %
                          </span>
                        )}

                        {item.title === "GCR" && item?.term_flag && (Number(item?.brand_term_commitment_rebate_per) > 0) && (

                          <div> <span className={`text-gray-700 ${item?.brand_term_commitment_rebate_per <= 0 ? "text-red-600" : "text-green-700"}`}>
                            {<>Term Commitment: {item?.brand_term_commitment_rebate_per} % </>}
                          </span>
                          </div>

                        )}

                      </div>
                      {
                        GCRPer?.hm_status === 1 && (
                          <span className="text-gray-700 invisible">
                            0.00 %
                          </span>
                        )
                      }

                    </Card>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
          {/* {userAuth?.email !== "anuja@grapetech.ae" && !chatBoxOpen && (
            <div className="chat-button" onClick={() => setChatOpen(true)}>
              💬 Let’s Chat
            </div>
          )} */}
        </Content>

        <Content className="min-h-screen sm:p-4 sm:pt-0 pt-4">
          {!isLoading && (
            <>
              <div className="bg-[#efecfc] p-4 border border-blue-300 rounded-md shadow-md w-full mx-auto -mt-3">
                <div className="flex items-center justify-between mb-4">
                  <h2 className="font-semibold text-lg">
                    Monthly Rebate Program
                  </h2>
                  <div className="flex items-center gap-2 text-gray-600 text-lg">
                    <InfoCircleOutlined />
                    <EllipsisOutlined />
                  </div>
                </div>

                <div className="  flex flex-wrap justify-between gap-4 w-full">
                  <div className="bg-[#efecfc] rounded-md p-4 w-full sm:w-[32%]">
                    <div className="bg-[#c5b8ff] text-sm px-2 py-1 rounded-md font-bold">
                      Total Rebate
                    </div>
                    <div className="text-2xl font-bold mb-3 px-2 py-1 bg-[#ded7fd] font-jetbrains">
                      ${" "}
                      {(isNaN(Number(GCRPer?.total_rebate_value))
                        ? 0
                        : Number(GCRPer.total_rebate_value)
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </div>
                    <div className="text-sm text-gray-700 leading-6">
                      <div className="flex">
                        <div className="w-1 h-6 rounded-full bg-purple-300 mr-2"></div>
                        <p className="block font-bold">
                          OneStop Generic Rebate :{" "}
                        </p>
                        <span className="ml-2">
                          {" "}
                          ${" "}
                          {Number(
                            GCRPer?.os_rebate_value || 0
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </div>
                      <div className="flex mt-3">
                        <div className="w-1 h-6 rounded-full bg-purple-300 mr-2"></div>
                        <p className="block font-bold">Brand Rebate:</p>
                        <span className="ml-2">
                          {" "}
                          ${" "}
                          {Number(
                            GCRPer?.brand_rebate_value || 0
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="bg-[#efecfc] rounded-md p-4 w-full sm:w-[32%]">
                    <div className="bg-[#c5b8ff] text-sm px-2 py-1 rounded-md font-bold">
                      OneStop Rebate Program
                    </div>
                    <div className="text-2xl font-bold mb-3 bg-[#ded7fd] px-2 py-1 font-jetbrains">
                      ${" "}
                      {Number(
                        GCRPer?.os_rebate_value || 0
                      ).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </div>
                    <div className="text-sm text-gray-700 space-y-1">
                      <div className="flex gap-1 items-center">
                        <div className="w-1 h-6 rounded-full bg-purple-300 "></div>
                        <span className="font-bold">Rebate:</span>
                        {
                          accSelectedOption === "option_1" && (
                            <span className="bg-[#ded7fd] text-xs px-1 py-0.5 rounded border border-gray-300 text-[12px]">
                              GCR:{" "}
                              {Number(GCRPer?.os_gcr_rebate_per || 0).toFixed(2)}
                              %
                            </span>
                          )}
                        <span className="bg-[#ded7fd] text-xs px-1 py-0.5 rounded border border-gray-300 text-[12px]">
                          GPR:{" "}
                          {Number(GCRPer?.os_gpr_rebate_per || 0).toFixed(2)}%
                        </span>

                        <span className={`bg-[#ded7fd] text-xs px-1 py-0.5 rounded border border-gray-300 text-[12px] ${GCRPer?.health_mart_bonus <= 0 ? 'text-red-700' : "text-green-700"}`}>
                          {GCRPer?.health_mart_bonus ? 
                          <>
                          HealthMart:{" "}
                          {Number(GCRPer?.health_mart_bonus || 0).toFixed(
                            2
                          )}
                          %
                           </>
                          : ""
                         
                        }
                        </span>

                        <span className="bg-[#ded7fd] text-xs px-1 py-0.5 rounded border border-gray-300 text-[12px]">
                          Total:{" "}
                          {Number(GCRPer?.os_total_rebate_per || 0).toFixed(
                            2
                          )}
                          %
                        </span>

                      </div>
                      <div className="flex mt-3">
                        <div className="w-1 h-6 rounded-full bg-purple-300 mr-2"></div>
                        <p className="font-bold mt-[8px]">OneStop Rx Total:</p>
                        <span className="bg-[#ded7fd] text-xs px-2 py-0.5 rounded border border-gray-300 mt-[8px] ml-2">
                          {" "}
                          ${" "}
                          {Number(
                            GCRPer?.raw_data?.Rebatable_OneStop_Rx || 0
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="bg-[#efecfc] rounded-md p-4 w-full sm:w-[32%]">
                    <div className="bg-[#c5b8ff] text-sm px-2 py-1 rounded-md font-bold">
                      Brand Rebate
                    </div>
                    <div className="text-2xl font-bold mb-3 bg-[#ded7fd] px-2 py-1 font-jetbrains">
                      ${" "}
                      {Number(GCRPer?.brand_rebate_value || 0).toLocaleString(
                        undefined,
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                      )}
                    </div>
                    <div className="text-sm text-gray-700 space-y-1">
                      <div className="flex gap-2 items-center">
                        <div className="w-1 h-6 rounded-full bg-purple-300"></div>
                        <span className="font-bold">Rebate:</span>
                        <span className="bg-[#ded7fd] text-xs px-2 py-0.5 rounded border border-gray-300">
                          GCR:{" "}
                          {Number(GCRPer?.brand_gcr_rebate_per || 0).toFixed(2)}%
                        </span>
                        {/* <span className="bg-[#ded7fd] text-xs px-2 py-0.5 rounded border border-gray-300">
                          GPR:{" "}
                          {Number(GCRPer?.brand_gpr_rebate || 0).toFixed(2)}%
                        </span> */}
                        {
                          GCRPer?.term_commitment_flag === "Y" && (Number(GCRPer?.brand_term_commitment_rebate_per) > 0) && (
                            <span className={`bg-[#ded7fd] text-xs px-1 py-0.5 rounded border border-gray-300 text-[12px] ${GCRPer?.brand_term_commitment_rebate_per <= 0 ? 'text-red-700' : "text-green-700"}`}>
                              Term Commitment:{" "}
                              {Number(GCRPer?.brand_term_commitment_rebate_per || 0).toFixed(
                                2
                              )}
                              %
                            </span>
                          )
                        }
                        <span className="bg-[#ded7fd] text-xs px-2 py-0.5 rounded border border-gray-300">
                          Total:{" "}
                          {Number(GCRPer?.brand_total_rebate_per || 0).toFixed(2)}%
                        </span>
                      </div>
                      <div className="flex mt-3">
                        <div className="w-1 h-6 rounded-full bg-purple-300 mr-2"></div>
                        <p className="font-bold mt-[8px]">
                          Rebatable Brand Total:
                        </p>{" "}
                        <span className="bg-[#ded7fd] text-xs px-2 py-0.5 rounded border border-gray-300 mt-[8px] ml-2">
                          ${" "}
                          {Number(
                            GCRPer?.raw_data?.Rebatable_Brand_Rx || 0
                          ).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Row gutter={[16, 16]} className="mb-8 mt-5">
                <Col xs={24} md={12}>
                  <Card
                    title={
                      <div className="flex justify-between items-center">
                        <span className="cardtitle">Performance Scorecard</span>
                        <div className="flex items-center gap-4">
                          <div className="-mr-1">
                            <InfoCircleOutlined className="mr-2" />
                            <MoreOutlined />
                          </div>
                        </div>
                      </div>
                    }
                    className="bg-white h-full CardShadow cardAni tableCard-Custom"
                  >
                    <div className="flex mx-2">
                      <Tabs
                        activeKey={activePeriod}
                        onChange={(key) => setActivePeriod(key)}
                        className="custom-tabs w-full"
                        centered={true}
                      >
                        <TabPane tab="Current Period" key="current" />
                        <TabPane tab="Previous Period" key="previous" />
                      </Tabs>
                    </div>


                    {activePeriod == "current" ? (
                      <>
                        <div className="w-full overflow-x-auto scrollbar-hide">
                          <div className="min-w-[600px] max-h-[600px] overflow-y-auto ">
                            <div className="performance-table">
                              <div className=" row flex flex-wrap sm:flex-nowrap align-middle ">
                                <span className=" col metric w-full sm:w-1/3 font-bold">
                                  Metric
                                </span>
                                <span className="col right w-full sm:w-1/3 text-right font-bold ">
                                  {GCRPer?.raw_data?.month
                                    ? `MTD (${formatMonthLabel(
                                      GCRPer.raw_data?.month
                                    )})`
                                    : "MTD"}{" "}
                                  $
                                </span>
                                <span className="col right w-full sm:w-1/3 text-right font-bold  ">
                                  {GCRPer?.raw_quarter_data?.quarter
                                    ? `QTD (${formatQuarterLabel(
                                      GCRPer?.raw_quarter_data?.quarter
                                    )})`
                                    : "QTD"}{" "}
                                  $
                                </span>
                              </div>

                              <div className="row total flex flex-wrap sm:flex-nowrap">
                                <div
                                  className=" col metric w-full sm:w-1/3  text-2xl"
                                  style={{
                                    fontFamily: "Nunito Sans",
                                    fontWeight: "800",
                                  }}
                                >
                                  Total Rx
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right  text-2xl font-bold font-jetbrains">
                                  {Number(
                                    GCRPer?.raw_data?.Total_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right    text-2xl font-bold font-jetbrains">
                                  {Number(
                                    GCRPer?.raw_quarter_data?.Total_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>

                              <div className="row section-header  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 font-bold">
                                  Generic RX
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right font-bold">
                                  {Number(
                                    GCRPer?.raw_data?.Generic_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right font-bold">
                                  {Number(
                                    GCRPer?.raw_quarter_data?.Generic_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  OneStop Rx
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_data?.OnStop_Generic || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_quarter_data?.OnStop_Generic ||
                                    0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  RTL 2
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_data?.RTL2_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_quarter_data?.RTL2_Rx ||
                                    0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>

                              <div className="row section-header mt-5  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 font-bold">
                                  Brand RX
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right font-bold">
                                  {Number(
                                    GCRPer?.raw_data?.Brand_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right font-bold">
                                  {Number(
                                    GCRPer?.raw_quarter_data?.Brand_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>

                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  Rebatable Brand
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_data?.Rebatable_Brand_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_quarter_data
                                      ?.Rebatable_Brand_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>

                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  GLP1
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_data?.GLP1 || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_quarter_data?.GLP1 || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  HIV
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_data?.HIV_Sum || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_quarter_data?.HIV_Sum || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  Speciality (incl. HIV)
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_data?.Specialty || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_quarter_data?.Specialty || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  Flu + COVID
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_data?.totalFluCovid || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_quarter_data?.totalFluCovid || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  Biosim
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_data?.totalBiosim || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.raw_quarter_data?.totalBiosim || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              {
                                apiVersion !== "" &&
                                (
                                  <>
                                    <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                      <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                        MTF Drug
                                      </div>
                                      <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                        {Number(
                                          GCRPer?.raw_data?.totalMTF_Drug || 0
                                        ).toLocaleString(undefined, {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                      </div>
                                      <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                        {Number(
                                          GCRPer?.raw_quarter_data?.totalMTF_Drug || 0
                                        ).toLocaleString(undefined, {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                      </div>
                                    </div>
                                    {
                                      isBeforeOrEqualMarch2026 &&
                                      <>
                                        <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                          <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                            Projected MTF Drug
                                          </div>
                                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                            {Number(
                                              GCRPer?.raw_data?.projected_mtf_drug || 0
                                            ).toLocaleString(undefined, {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })}
                                          </div>
                                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                            {Number(
                                              GCRPer?.raw_quarter_data?.projected_mtf_drug || 0
                                            ).toLocaleString(undefined, {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })}
                                          </div>
                                        </div>

                                        <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                          <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                            WAC Dollar Impact
                                          </div>
                                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                            {Number(
                                              GCRPer?.raw_data?.wac_dollar_impact || 0
                                            ).toLocaleString(undefined, {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })}
                                          </div>
                                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                            {Number(
                                              GCRPer?.raw_quarter_data?.wac_dollar_impact || 0
                                            ).toLocaleString(undefined, {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })}
                                          </div>
                                        </div>
                                      </>
                                    }
                                  </>
                                )}
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="w-full overflow-x-auto scrollbar-hide">
                          <div className="min-w-[600px] max-h-[600px] overflow-y-auto">
                            <div className="performance-table">
                              <div className=" row flex flex-wrap sm:flex-nowrap align-middle ">
                                <span className=" col metric w-full sm:w-1/3 font-bold">
                                  Metric
                                </span>
                                <span className="col right w-full sm:w-1/3 text-right font-bold ">
                                  {GCRPer?.lastMetrics?.month
                                    ? `MTD (${formatMonthLabel(
                                      GCRPer?.lastMetrics?.month
                                    )})`
                                    : "MTD"}{" "}
                                  $
                                </span>
                                <span className="col right w-full sm:w-1/3 text-right font-bold  ">
                                  {GCRPer?.last_quarter_Metrics?.quarter
                                    ? `QTD (${formatQuarterLabel(
                                      GCRPer?.last_quarter_Metrics?.quarter
                                    )})`
                                    : "QTD"}{" "}
                                  $
                                </span>
                              </div>

                              <div className="row total flex flex-wrap sm:flex-nowrap">
                                <div
                                  className=" col metric w-full sm:w-1/3  text-2xl"
                                  style={{
                                    fontFamily: "Nunito Sans",
                                    fontWeight: "800",
                                  }}
                                >
                                  Total Rx
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right  text-2xl font-bold font-jetbrains">
                                  {Number(
                                    GCRPer?.lastMetrics?.Total_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right    text-2xl font-bold font-jetbrains">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics?.Total_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>

                              <div className="row section-header  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 font-bold">
                                  Generic RX
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right font-bold">
                                  {Number(
                                    GCRPer?.lastMetrics?.Generic_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right font-bold">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics?.Generic_Rx ||
                                    0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  OneStop Rx
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.lastMetrics?.OnStop_Generic || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics
                                      ?.OnStop_Generic || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>

                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  RTL 2
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.lastMetrics?.RTL2_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics
                                      ?.RTL2_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>

                              <div className="row section-header mt-5  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 font-bold">
                                  Brand RX
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right font-bold">
                                  {Number(
                                    GCRPer?.lastMetrics?.Brand_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right font-bold">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics?.Brand_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>

                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  Rebatable Brand
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.lastMetrics?.Rebatable_Brand_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics
                                      ?.Rebatable_Brand_Rx || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>

                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  GLP1
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.lastMetrics?.GLP1 || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics?.GLP1 || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  HIV
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.lastMetrics?.HIV_Sum || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics?.HIV_Sum || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  Speciality (incl. HIV)
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.lastMetrics?.Specialty || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics?.Specialty || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  Flu + COVID
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.lastMetrics?.totalFluCovid || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics
                                      ?.totalFluCovid || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>
                              <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                  Biosim
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.lastMetrics?.totalBiosim || 0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                                <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                  {Number(
                                    GCRPer?.last_quarter_Metrics?.totalBiosim ||
                                    0
                                  ).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </div>
                              </div>

                              {
                                apiVersion !== "" && (
                                  <>
                                    <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                      <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                        MTF Drug
                                      </div>
                                      <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                        {Number(
                                          GCRPer?.lastMetrics?.totalMTF_Drug || 0
                                        ).toLocaleString(undefined, {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                      </div>
                                      <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                        {Number(
                                          GCRPer?.last_quarter_Metrics?.totalMTF_Drug || 0
                                        ).toLocaleString(undefined, {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                      </div>
                                    </div>
                                    {
                                      isBeforeOrEqualMarch2026 &&
                                      <>
                                        <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                          <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                            Projected MTF Drug
                                          </div>
                                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                            {Number(
                                              GCRPer?.lastMetrics?.projected_mtf_drug || 0
                                            ).toLocaleString(undefined, {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })}
                                          </div>
                                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                            {Number(
                                              GCRPer?.last_quarter_Metrics?.projected_mtf_drug || 0
                                            ).toLocaleString(undefined, {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })}
                                          </div>
                                        </div>

                                        <div className="row section-lightBlue  flex flex-wrap sm:flex-nowrap">
                                          <div className=" col metric w-full sm:w-1/3 text-[#606783]">
                                            WAC Dollar Impact
                                          </div>
                                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                            {Number(
                                              GCRPer?.lastMetrics?.wac_dollar_impact || 0
                                            ).toLocaleString(undefined, {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })}
                                          </div>
                                          <div className="col right w-full sm:w-1/3 text-right text-[#606783]">
                                            {Number(
                                              GCRPer?.last_quarter_Metrics?.wac_dollar_impact || 0
                                            ).toLocaleString(undefined, {
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2,
                                            })}
                                          </div>
                                        </div>
                                      </>
                                    }
                                  </>
                                )}

                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </Card>
                </Col>

                <Col xs={24} md={12}>
                  <Card
                    title={
                      <div className="flex justify-between items-center">
                        <div className="cardtitle mb-1">
                          Trailing Monthly Rebate Performance
                        </div>
                        <div className="flex items-center gap-2 cardtitle2">
                          <div className="-mr-1">
                            <InfoCircleOutlined className="mr-2" />
                            <MoreOutlined />
                          </div>
                        </div>
                      </div>
                    }
                    className="bg-white h-full CardShadow cardAni"
                  >
                    <div className="w-full overflow-x-auto scrollbar-hide">
                      <div className="min-w-[590px]">
                        <ResponsiveContainer width="100%"
                          // aspect={1}
                          height={600}
                        >
                          <BarChart
                            data={processedRebateData}
                            barSize={50}
                            barGap={2}
                            barCategoryGap="10%"
                            margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
                          >
                            <defs>
                              <pattern
                                id="patternGPR"
                                patternUnits="userSpaceOnUse"
                                width="10"
                                height="10"
                              >
                                <rect width="10" height="10" fill="#0B9CE9" />
                                <path
                                  d="M0,10 l10,-10 M-2,2 l4,-4 M8,12 l4,-4"
                                  stroke="rgba(255,255,255,0.2)"
                                  strokeWidth="4"
                                />
                              </pattern>
                              <pattern
                                id="patternGCR"
                                patternUnits="userSpaceOnUse"
                                width="10"
                                height="10"
                              >
                                <rect width="10" height="10" fill="#001997" />
                                <path
                                  d="M0,10 l10,-10"
                                  stroke="rgba(255,255,255,0.2)"
                                  strokeWidth="4"
                                />
                              </pattern>
                              <pattern
                                id="patternSGPR"
                                patternUnits="userSpaceOnUse"
                                width="10"
                                height="10"
                              >
                                <rect width="10" height="10" fill="#FF9635" />
                                <path
                                  d="M0,10 l10,-10"
                                  stroke="rgba(255,255,255,0.2)"
                                  strokeWidth="4"
                                />
                              </pattern>
                              <pattern
                                id="patternSGCR"
                                patternUnits="userSpaceOnUse"
                                width="10"
                                height="10"
                              >
                                <rect width="10" height="10" fill="#009767" />
                                <path
                                  d="M0,10 l10,-10"
                                  stroke="rgba(255,255,255,0.2)"
                                  strokeWidth="4"
                                />
                              </pattern>
                              <pattern
                                id="patternRGCR"
                                patternUnits="userSpaceOnUse"
                                width="10"
                                height="10"
                              >
                                <rect width="10" height="10" fill="#6f0097" />
                                <path
                                  d="M0,10 l10,-10"
                                  stroke="rgba(255,255,255,0.2)"
                                  strokeWidth="4"
                                />
                              </pattern>
                            </defs>

                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="month" />
                            {/* <YAxis
                              tickFormatter={(value) =>
                                `$${(value / 1000).toFixed(0)}k`
                              }
                            /> */}
                            <YAxis
                              tickCount={5}
                              tickFormatter={(value) => {
                                if (value >= 1000) return `$${(value / 1000).toFixed(1)}k`;
                                return `$${value.toFixed(0)}`;
                              }}
                            />
                            <Tooltip
                              formatter={(value) =>
                                `$${value?.toFixed(2)}`
                              }
                            />
                            <Legend />
                            <Bar
                              dataKey="Brand_Rebate_GCR_Value"
                              stackId="a"
                              fill="url(#patternGPR)"
                              name="Brand Rebate GCR"
                            />
                            <Bar
                              dataKey="Brand_Rebate_TC_value"
                              stackId="a"
                              fill="url(#patternGCR)"
                              name="Brand Rebate TC"
                            />
                            <Bar
                              dataKey="OneStop_Rebate_GPR_value"
                              stackId="a"
                              fill="url(#patternSGPR)"
                              name="One Stop Rebate GPR"
                            />
                            <Bar
                              dataKey="OneStop_Rebate_HM_value"
                              stackId="a"
                              fill="url(#patternSGCR)"
                              name="OneStop Rebate HM"
                            />
                            {
                              accSelectedOption === "option_1" && (
                                <Bar
                                  dataKey="OneStop_Rebate_GCR_value"
                                  stackId="a"
                                  fill="url(#patternRGCR)"
                                  name="OneStop Rebate GCR"
                                />
                              )
                            }

                          </BarChart>
                        </ResponsiveContainer>
                      </div>
                    </div>
                  </Card>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="mb-8">
                <Col xs={24} md={12}>
                  <Card
                    title={
                      <div className="flex justify-between items-center">
                        <div className="cardtitle">GPR Trailing Data</div>
                        <div className="-mr-1">
                          <InfoCircleOutlined className="mr-2" />
                          <MoreOutlined />
                        </div>
                      </div>
                    }
                    className="bg-white h-full CardShadow cardAni"
                  >
                    <div className="w-full overflow-x-auto scrollbar-hide">
                      <div className="min-w-[600px]">
                        <ResponsiveContainer width="100%" height={500}>
                          <BarChart
                            data={TrailingData ? TrailingData.slice(-6) : []}
                            barGap={10}
                            barSize={30}
                            margin={{ top: 5, right: 5, left: 30, bottom: 40 }}
                          >
                            <defs>
                              <pattern
                                id="patternGPR"
                                patternUnits="userSpaceOnUse"
                                width="10"
                                height="10"
                              >
                                <rect width="10" height="10" fill="#A5D6F3" />
                                <path
                                  d="M0,10 l10,-10"
                                  stroke="rgba(255,255,255,0.3)"
                                  strokeWidth="4"
                                />
                              </pattern>

                              <pattern
                                id="patternGPRDark"
                                patternUnits="userSpaceOnUse"
                                width="10"
                                height="10"
                              >
                                <rect width="10" height="10" fill="#033d61ff" />{" "}
                                {/* Darker shade */}
                                <path
                                  d="M0,10 l10,-10"
                                  stroke="rgba(255,255,255,0.3)"
                                  strokeWidth="4"
                                />
                              </pattern>
                            </defs>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis
                              dataKey="period"
                              tick={{
                                fontSize: 12,
                                fill: "#000833",
                                fontWeight: 600,
                                fontFamily: "Nunito Sans",
                              }}
                              label={{
                                value: "Months",
                                position: "bottom",
                                dy: 20,
                                style: {
                                  textAnchor: "middle",
                                  fill: "#000833",
                                  fontSize: 14,
                                  fontWeight: 700,
                                  fontFamily: "Nunito Sans",
                                },
                              }}
                            />

                            <YAxis
                              domain={[0, 120]}
                              ticks={[...Array(25)].map((_, i) => i * 5)}
                              tick={{
                                fill: "#000833",
                                fontWeight: 600,
                                fontFamily: "Nunito Sans",
                                fontSize: 12,
                              }}
                              label={{
                                value: "GPR, % (Average)",
                                angle: -90,
                                dx: -20,
                                style: {
                                  fontWeight: 700,
                                  fill: "#1d2330",
                                  fontSize: 14,
                                  fontFamily: "Nunito Sans",
                                },
                              }}
                            />
                            <Tooltip
                              formatter={(value) => [
                                `${value.toFixed(2)}%`,
                                "Monthly GPR",
                              ]}
                            />
                            <Legend
                              verticalAlign="top"
                              align="center"
                              height={30}
                              wrapperStyle={{
                                fontWeight: 600,
                                fontFamily: "Nunito Sans",
                                fontSize: 14,
                                color: "#000833",
                              }}
                            />

                            <Bar
                              dataKey="per_month_gpr"
                              name="Monthy GPR"
                              fill="url(#patternGPR)"
                              radius={[4, 4, 0, 0]}
                            />

                            {/* <Bar
                              dataKey="avg_6_month"
                              name="6 Month GPR"
                              fill="url(#patternGPRDark)"
                              radius={[4, 4, 0, 0]}
                            /> */}
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
                    </div>
                  </Card>
                </Col>
                <Col xs={24} md={12}>
                  <Card
                    title={
                      <div className="flex justify-between items-center">
                        <span className="cardtitle">
                          Top RX Generic Purchase (Positive Impact)
                        </span>
                        <div className="-mr-1">
                          <InfoCircleOutlined
                            className="mr-2 cursor-pointer"
                            onClick={() => navigate("/data_table_gcr")}
                          />
                          <MoreOutlined />
                        </div>
                      </div>
                    }
                    className="bg-white h-full CardShadow cardAni tableCard-Custom"
                  >
                    <div
                      className="overflow-x-auto  scrollbar-hide"
                      style={{ maxWidth: "100%" }}
                    >
                      <Table
                        className="border-table"
                        style={{ marginTop: "-20px", minWidth: "600px" }}
                        dataSource={TopRxSpentSQL.map((item, index) => ({
                          ...item,
                          key: `rx-${item.drug_name}-${index}` || `rx-${index}`,
                        }))}
                        pagination={false}
                        scroll={{ x: "max-content", y: "400px" }}
                        columns={[
                          {
                            title: "Drug Name",
                            dataIndex: "drug_name",
                            key: "drug_name",
                            width: "60%",
                            render: (value) => value || "-",
                          },
                          {
                            title: "Quantity",
                            dataIndex: "quantity_sold",
                            key: "quantity_sold",
                            align: "right",
                            width: "22%",
                            render: (value) =>
                              isNaN(Number(value))
                                ? "0"
                                : Math.round(Number(value)).toLocaleString(),
                          },
                          {
                            title: "Spend ($)",
                            dataIndex: "total_spend",
                            key: "total_spend",
                            align: "right",
                            width: "20%",
                            render: (value) => {
                              const num = Number(value);
                              if (isNaN(num)) return "0.00";
                              return num >= 1_000_000
                                ? (num / 1_000_000).toFixed(2) + "M"
                                : num.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                });
                            },
                          },
                        ]}
                      />
                    </div>
                  </Card>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="mt-4">
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Card
                    title={
                      <div className="flex flex-wrap justify-between items-center gap-y-2">
                        <span className="cardtitle text-base md:text-lg">
                          Top Leakage Dollar (Negative Impact)
                        </span>
                        <div className="flex items-center space-x-2 -mr-1">
                          <InfoCircleOutlined
                            className="cursor-pointer"
                            onClick={() => navigate("/data_table_gpr")}
                          />
                          <MoreOutlined />
                        </div>
                      </div>
                    }
                    className="bg-white CardShadow cardAni tableCard-Custom"
                  >
                    <div className="overflow-x-auto">
                      <Table
                        className="border-table custom-scrollbar min-w-[800px]"
                        style={{ marginTop: "-20px" }}
                        dataSource={TopLeakDetails.map((item, index) => ({
                          ...item,
                          key: `leak-${item.trans_id || index}`,
                        }))}
                        pagination={false}
                        scroll={{ x: "max-content", y: 400 }}
                        columns={[
                          {
                            title: "Rank",
                            dataIndex: "Rank",
                            key: "Rank",
                            render: (value) => value || "-",
                            width: "10%",
                          },
                          {
                            title: "GCN",
                            dataIndex: "GCN",
                            key: "GCN",
                            width: "15%",
                            render: (value, record) => {
                              const gcn = value?.trim() || null;
                              // const ndcDesc =
                              //   record["NDC Description"]?.trim() || null;

                              if (!gcn) return "-";

                              return (
                                <div className="font-semibold">
                                  {gcn}
                                </div>
                              );
                            },
                          },
                          {
                            title: "NDC",
                            dataIndex: "NDC",
                            key: "NDC",
                            width: "15%",
                            render: (value, record) => {
                              const ndc = value?.trim() ?? null;
                              // const ndcDesc =
                              //   record["NDC Description"]?.trim() || null;

                              if (!ndc) return "-";

                              return (
                                <div className="font-semibold">
                                  {ndc}
                                </div>
                              );
                            },
                          },
                          {
                            title: "NDC Description",
                            dataIndex: "NDC Description",
                            key: "NDC Description",
                            width: "30%",
                            align:"center",
                            sorter: false,
                            render: (val) =>
                                    val === undefined || val === "" || val === null ? "-" : val
                          },
                          {
                            title: "Brand / Generic",
                            dataIndex: "BrandOrGeneric",
                            key: "BrandOrGeneric",
                            width: "20%",
                            align:"center",
                            sorter: false,
                            render: (val) =>
                                    val === undefined || val === "" || val === null ? "-" : val
                          },
                          {
                            title: "GPR Effect at GCN Level, %",
                            dataIndex: "GprEffectPct",
                            key: "GprEffectPct",
                            align: "right",
                            width: "20%",
                            sorter: (a, b) =>
                              parseFloat(a["GprEffectPct"] || 0) -
                              parseFloat(b["GprEffectPct"] || 0),
                            defaultSortOrder: "ascend",
                            render: (value) => {
                              const numValue = parseFloat(value) || 0;
                              return (
                                <div className="flex justify-end items-center gap-1">
                                  <span>{numValue.toFixed(5)}</span>
                                  {numValue < 0 ? (
                                    <ArrowDownOutlined
                                      style={{ color: "red" }}
                                    />
                                  ) : (
                                    <ArrowUpOutlined
                                      style={{ color: "green" }}
                                    />
                                  )}
                                </div>
                              );
                            },
                          },

                          {
                            title: "Purchases (Units)",
                            dataIndex: "PurchaseUnits",
                            key: "PurchaseUnits",
                            align: "right",
                            width: "15%",
                            render: (value) =>
                              isNaN(Number(value))
                                ? "0.00"
                                : Number(value).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }),
                          },
                          {
                            title: "Dispenses (Units)",
                            dataIndex: "DispenseUnits",
                            key: "DispenseUnits",
                            align: "right",
                            width: "15%",
                            render: (value) =>
                              isNaN(Number(value))
                                ? "0.00"
                                : Number(value).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }),
                          },
                          {
                            title: "Estimated Leakage ($)",
                            dataIndex: "EstimatedLeakage",
                            width: "15%",
                            key: "trans_id",
                            align: "right",
                            render: (value) =>
                              isNaN(Number(value))
                                ? "0.00"
                                : Number(value).toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }),
                          },
                        ]}
                      />
                    </div>
                  </Card>
                </Col>
              </Row>


            </>
          )}
        </Content>
      </Layout>
      <AlertMessage
        isVisible={modalVisible}
        onClose={() => setModalVisible(false)}
      />
      <CalculationModal
        isVisible={isVisible}
        onClose={() => setIsVisible(false)}
        data={calculatedData}
        setCalculatedData={setCalculatedData}
        dropdownOptions={gcrPercentage}
        fetchCalculationData={fetchCalculationData}
        selectedGcr={selectedGcr}
        setSelectedGcr={setSelectedGcr}
        isloading={loadingCalc}
        month={selectedOption?.value}
        fetchgprPercentage={fetchgprPercentage}
        setMonth={setSelectedOption}
        selectedPharmacies={selectedPharmacies}
        setIsLoading={setloadingCalc}
        accSelectedOption = {accSelectedOption}
      />
      <Chat open={chatBoxOpen} setOpen={setChatOpen} />
      <InputPopUp
        isVisible={targetPopUP}
        onClose={() => setTargetPopUp(false)}
        selectedValue={selectedValue}
        // getTargetData={getTargetData}
        month={selectedOption?.value}
        year={selectedOption?.year}
        pharmacy={selectedPharmacies}
        name={userAuth?.first_name}
        value={inputTargetValue}
        email={userAuth?.email}
        currentVal={GCRPer}
        Quarter_GCR={quarterGCRTarget}
        Month_SGCR={SGCRTarget}
        Monthly_GPR={GPRTarget}
      />
    </>
  );
};

export default NewDashboard;
